import 'owa-addins-osfruntime';
import * as StoreHelper from '../util/InClientStoreHelper';
import * as InstallExtension from '../services/InstallExtension';
import * as RegisterTelemetryInfoFromOutlook from '../services/TelemetryInfoFromOutlook';
import * as GetAllInstalledExtensions from '../services/GetAllInstalledExtensions';
import * as DisableOutlookWebExt from '../services/DisableOutlookWebExt';
import * as GetAllPrivateAddins from '../services/GetAllPrivateAddIns';
import * as UninstallOutlookWebExt from '../services/UninstallOutlookWebExt';
import * as InstallOutlookWebExtByManifest from '../services/InstallOutlookWebExtByManifest';
import * as InstallOutlookWebExtByManifestUrl from '../services/InstallOutlookWebExtByManifestUrl';
import * as InstallOutlookWebExtByProductId from '../services/InstallOutlookWebExtByProductId';
import * as EnableApp from '../services/EnableApp';
import * as LaunchUrl from '../services/LaunchUrl';
import * as UpdateAddinPinOptions from '../services/UpdateAddinPinOptions';

export function registerMethods(serviceEndPoint: OSF.ServiceEndpoint, storeUrl: string) {
    RegisterTelemetryInfoFromOutlook.registerMethod(serviceEndPoint);
    GetAllInstalledExtensions.registerMethod(serviceEndPoint);
    GetAllPrivateAddins.registerMethod(serviceEndPoint);
    InstallExtension.registerMethod(serviceEndPoint);
    DisableOutlookWebExt.registerMethod(serviceEndPoint);
    UninstallOutlookWebExt.registerMethod(serviceEndPoint);
    InstallOutlookWebExtByManifest.registerMethod(serviceEndPoint);
    InstallOutlookWebExtByManifestUrl.registerMethod(serviceEndPoint);
    InstallOutlookWebExtByProductId.registerMethod(serviceEndPoint);
    EnableApp.registerMethod(serviceEndPoint);
    LaunchUrl.registerMethod(serviceEndPoint);
    UpdateAddinPinOptions.registerMethod(serviceEndPoint);

    serviceEndPoint.registerConversation(StoreHelper.getConversationId(), storeUrl, null, null);
}
